// extracted by mini-css-extract-plugin
export default {"cls1":"LebrsWWRh0Rv88Lil24f","cls2":"WA31nZigDvuCcn3T6Z87 LebrsWWRh0Rv88Lil24f","showBorder":"R0nDmsDpxvUiUeo5aQXm"};